var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 12.0077L12.9962 5.61155L12.2885 4.90385L6.6 10.5923L3.75 7.7423L3.0423 8.45L6.6 12.0077ZM1.61538 16.5C1.15513 16.5 0.770833 16.3458 0.4625 16.0375C0.154167 15.7292 0 15.3449 0 14.8846V2.11537C0 1.65512 0.154167 1.27083 0.4625 0.9625C0.770833 0.654167 1.15513 0.5 1.61538 0.5H14.3846C14.8449 0.5 15.2292 0.654167 15.5375 0.9625C15.8458 1.27083 16 1.65512 16 2.11537V14.8846C16 15.3449 15.8458 15.7292 15.5375 16.0375C15.2292 16.3458 14.8449 16.5 14.3846 16.5H1.61538ZM1.61538 15.5H14.3846C14.5385 15.5 14.6795 15.4359 14.8077 15.3077C14.9359 15.1795 15 15.0385 15 14.8846V2.11537C15 1.96154 14.9359 1.82052 14.8077 1.6923C14.6795 1.5641 14.5385 1.5 14.3846 1.5H1.61538C1.46154 1.5 1.32052 1.5641 1.1923 1.6923C1.0641 1.82052 1 1.96154 1 2.11537V14.8846C1 15.0385 1.0641 15.1795 1.1923 15.3077C1.32052 15.4359 1.46154 15.5 1.61538 15.5Z",
    fill: "#383ECB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedFlat);
export default __webpack_public_path__ + "static/media/icon-checked-flat.4152dda11cdae6e53b5abc077ad04e76.svg";
export { ForwardRef as ReactComponent };